'use strict';

import React from 'react';
import { Link } from 'react-router';
import UserStore from 'stores/UserStore';
import API from 'sources/API';
import 'styles/Footer.scss';

class FooterComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exploreActive: false,
      albumsActive: false,
      userActive: false,
      opportunitiesActive: false,
      storeActive: false,
      destinationsActive: false,
      accessToken: UserStore.getState().accessToken
    }
  }
  componentDidMount() {
    if(this.props.activeTab) {
      let activeState = {};
      let activeKey = `${this.props.activeTab}Active`;
      activeState[activeKey] = true;
      this.setState(activeState);
    }
  }
  render() {
    let userLink;
    if(this.state.accessToken) { //已登录
      userLink = (
        <Link to='/center' activeClassName="active" className={this.state.userActive ? 'columns active' : 'columns'}>
          <i className="fa fa-user-o" aria-hidden="true"></i>
          <div className="fz10">我的</div>
        </Link>
      );
    } else { //未登录
      if(API.isWechat) {
        userLink = (
          <a href={API.redirectWechatLogin} className={this.state.userActive ? 'columns active' : 'columns'}>
            <i className="fa fa-user-o" aria-hidden="true"></i>
            <div className="fz10">我的</div>
          </a>
        );
      } else {
        userLink = (
          <Link to='/login' activeClassName="active" className={this.state.userActive ? 'columns active' : 'columns'}>
            <i className="fa fa-user-o" aria-hidden="true"></i>
            <div className="fz10">我的</div>
          </Link>
        );
      }
    }
    
    return (
      <div className="footer-component expanded small-up-5">
        <Link to="/store" activeClassName="active" className={this.state.storeActive? 'columns active' : 'columns'}>
          <i className="fa fa-circle-thin" aria-hidden="true"></i>
          <div className="fz10">探索</div>
        </Link>
        <Link to="/destinations" activeClassName="active" className={this.state.destinationsActive? 'columns active' : 'columns'}>
          <i className="fa fa-map-o" aria-hidden="true" style={{fontSize: '16px'}}></i>
          <div className="fz10" style={{marginTop: '3px'}}>目的地</div>
        </Link>
        <Link to="/medias" activeClassName="active" className={this.state.exploreActive ? 'columns active' : 'columns'}>
          <i className="fa fa-lemon-o" aria-hidden="true"></i>
          <div className="fz10">单点</div>
        </Link>
        {/* <Link to="/teams" activeClassName="active" className={this.state.teamsActive ? 'columns active' : 'columns'}>
          <i className="fa fa-hourglass-o" aria-hidden="true"></i>
          <div className="fz10">团期</div>
        </Link> */}
        <Link to="/albums" activeClassName="active" className={this.state.albumsActive ? 'columns active' : 'columns'}>
          <i className="fa fa-clone" aria-hidden="true"></i>
          <div className="fz10">美文</div>
        </Link>
        {userLink}
      </div>
    );
  }
}

FooterComponent.displayName = 'FooterComponent';

// Uncomment properties you need
// FooterComponent.propTypes = {};
// FooterComponent.defaultProps = {};

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/FooterComponent.js